export function formatDate(date) {
  var date = new Date(date);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + (date.getDate() ) : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + (date.getHours() ) : date.getHours()) + ''//date.getHours() ;
  var m = date.getMinutes() +"";
  var s = date.getSeconds()+"";
  // if(h<10) {
	 // h=0+h 
  // }
  if(date.getMinutes()<10){
	  m=0+m
  } 
  if(date.getSeconds()<10){
	 s=0+s
  } 
  return Y+ M + D + h+':' + m+':'+s;
  // return  M + D + h+ ':' + m;
}

export function formatDate2(date) {
  var date = new Date(date);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + (date.getDate() ) : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + (date.getHours() ) : date.getHours()) + ''//date.getHours() ;
  var m = date.getMinutes() +"";
  var s = date.getSeconds()+"";
  // if(h<10) {
	 // h=0+h 
  // }
  if(date.getMinutes()<10){
	  m=0+m
  } 
  if(date.getSeconds()<10){
	 s=0+s
  } 
  // return Y+ M + D + h+':' + m+':'+s;
  return  M + D + h+ ':' + m;
}